import axios from 'axios'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'

/**
 * Édition des données véhicule (photos version, courbes dyno, liens datalog, notes internes)
 * poussées vers Shiftech-API. Chaque appel renvoie la VehicleEngineResource rafraîchie
 * (réponse directe de l'API), à réassigner côté vue via onUpdated.
 */
export function useChiptuningEdit({ onUpdated = () => {}, onError = () => {} } = {}) {
    const $toast = useToast()
    const saving = ref(false)

    const base = (engineId) => `/api/chiptuning/${engineId}`

    const buildFormData = (field, files, extra = {}) => {
        const formData = new FormData()
        Array.from(files).forEach((file, index) => formData.append(`${field}[${index}]`, file))
        Object.entries(extra).forEach(([key, value]) => formData.append(key, value))
        return formData
    }

    const run = async (request, successMessage) => {
        try {
            saving.value = true
            const { data } = await request
            if (successMessage) {
                $toast.success(successMessage, { position: 'top', duration: 4000, dismissible: true, pauseOnHover: true })
            }
            onUpdated(data)
            return data
        } catch (error) {
            onError(error)
            throw error
        } finally {
            saving.value = false
        }
    }

    const uploadPhotos = (engineId, files) =>
        run(axios.post(`${base(engineId)}/photos`, buildFormData('medias', files)), 'Photo(s) ajoutée(s)')

    const uploadDynoCharts = (engineId, files, stage) =>
        run(axios.post(`${base(engineId)}/dyno-charts`, buildFormData('medias', files, { stage })), 'Courbe(s) ajoutée(s)')

    const addDatalogLink = (engineId, url, name, stage) =>
        run(axios.post(`${base(engineId)}/datalog-links`, { url, name, stage }), 'Lien de datalog ajouté')

    const updateInternalNote = (engineId, stage, note) =>
        run(axios.put(`${base(engineId)}/internal-notes`, { stage, note }), 'Note interne enregistrée')

    return {
        saving,
        uploadPhotos,
        uploadDynoCharts,
        addDatalogLink,
        updateInternalNote,
    }
}
